import { useQuery } from 'react-query'
import axios, { AxiosError } from 'axios'
import { getEveryStickerCategoryPathname } from '../../api/pathname'
import * as Sentry from '@sentry/react'
import rootHistory from '../../rootHistory'
import { notiFormForError } from '../../components/notificationForm'
import { useIntl } from 'react-intl'

const twentyFourHoursInMs = 1000 * 60 * 60 * 24

export const getStickerCategoryAPI = async () => {
  const { data } = await axios.get(getEveryStickerCategoryPathname, {
    headers: {
      'Cache-Control': 'max-age=100000000',
    },
  })
  return data
}

export const useEveryStickerCategory = () => {
  const intl = useIntl()
  return useQuery('every-sticker-category', getStickerCategoryAPI, {
    staleTime: twentyFourHoursInMs,
    onError: (e: AxiosError) => {
      rootHistory.push('/')
      notiFormForError(
        intl.locale,
        intl.formatMessage({ id: 'Upload.packages.serverError' }),
      )
      console.dir(e)
      Sentry.captureException(
        new Error('every-sticker-category message :: ' + e.message),
      )
    },
  })
}
